import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ExternalSettings } from '../../../services/external-settings/external-settings.interface';
import { ExternalSettingsService } from '../../../services/external-settings/external-settings.service';
import { ResponsiveDesignService } from '../../../services/responsive-design/responsive-design.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';

/** Result of the App Authenticator "did not receive notification" options dialog. */
export type AppAuthenticatorNoNotificationChoice = 'resend' | 'sendCode' | 'cancel';

@Component({
  selector: 'app-app-authenticator-no-notification',
  templateUrl: './app-authenticator-no-notification.component.html',
  styleUrls: ['./app-authenticator-no-notification.component.less'],
  standalone: false,
})
export class AppAuthenticatorNoNotificationComponent implements OnInit {

  UIUtilityService: any = UIUtilityService;
  externalSettings!: ExternalSettings;

  constructor(
    public dialogRef: MatDialogRef<AppAuthenticatorNoNotificationComponent, AppAuthenticatorNoNotificationChoice>,
    private srvES: ExternalSettingsService,
    protected srvRpDesign: ResponsiveDesignService,
  ) { }

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((settings) => {
      this.externalSettings = settings;
    });
  }

  onResend(): void {
    this.dialogRef.close('resend');
  }

  onSendCode(): void {
    this.dialogRef.close('sendCode');
  }

  onCancel(): void {
    this.dialogRef.close('cancel');
  }
}
